"use client";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import {
  TypeMultiPackageTeaser,
  isTypePackageDetailItem,
} from "@contentful/types";
import { notEmpty } from "@yardzen/js-util";
import { H1 } from "@yardzen/ui/components/h1";
import { cn } from "@yardzen/ui/lib/utils";
import { useSearchParams } from "next/navigation";
import { ImageCollection } from "./ImageCollection";
import { PackageCard } from "./PackageCard";

export const MultiPackageTeaserBlocks: React.FC<{
  multiPackageTeaser: TypeMultiPackageTeaser<"WITHOUT_UNRESOLVABLE_LINKS">;
  checkoutV2Enabled: boolean;
}> = ({ multiPackageTeaser, checkoutV2Enabled }) => {
  const {
    moduleHeading,
    moduleSubheading,
    packages,
    isRecommendedHeader,
    showImages,
    packageDetailPageVariant,
    carousel,
  } = multiPackageTeaser?.fields || {};
  const queryParams = useSearchParams();
  const packageId = queryParams.get("option");
  console.log(packageId);
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center px-1 pb-8 md:px-8",
        packageDetailPageVariant
          ? "mt-0 pt-0 max-md:mt-0"
          : "mt-5 pt-8 max-md:mt-4 md:pt-8",
      )}
    >
      <div>
        {isRecommendedHeader && (
          <span className="font-body text-lg">{isRecommendedHeader}</span>
        )}
      </div>
      <div className="flex flex-col items-center justify-center gap-4 p-5">
        <H1>{moduleHeading}</H1>
        {moduleSubheading && (
          <div className="text-brand-primary-regular max-w-5xl text-center text-base">
            {documentToReactComponents(moduleSubheading)}
          </div>
        )}
      </div>

      <div className="flex w-full max-w-7xl flex-col items-start justify-center gap-4 md:flex-row md:items-stretch">
        {packages
          ?.filter(notEmpty)
          .filter(isTypePackageDetailItem)
          .map((package_card) => (
            <PackageCard
              key={package_card?.sys.id}
              keyVal={package_card?.sys.id}
              package_card={package_card}
              showImages={showImages}
              packageDetailPageVariant={packageDetailPageVariant}
              packageId={packageId}
              checkoutV2Enabled={checkoutV2Enabled}
            />
          ))}
        {carousel && (
          <div className="w-full min-w-0 md:flex-1 md:basis-0">
            <ImageCollection
              imageCollection={carousel}
              variant={"detail"}
              slideClassName="h-[220px] object-cover"
            />
          </div>
        )}
      </div>
    </div>
  );
};
